<template>
  <div
    class="flex flex-col"
    :class="{ 'p-[5px]': smallSvg, '!pb-0': smallSvg && DockStatus }"
  >
    <!-- Interrompre le vol -->
    <div v-if="canKill" class="flex justify-between items-center mb-2">
      <span> {{ $e("Interrompre un démarrage de vol qui est bloqué") }} :</span>
      <button
        @click.stop.prevent="kill_flight()"
        :class="classBtn"
        class="!bg-error"
      >
        {{ $e("Interrompre") }}
      </button>
    </div>

    <!-- Dock debug -->
    <div class="content_device_action">
      <div
        @click="dock_debug()"
        v-if="
          ( DockStatus && $root.user.can([3,4,5], 'DEVICES.DEBUG.DOCK.debug_mode_cancel') ) ||
          ( !DockStatus && $root.user.can([3,4,5], 'DEVICES.DEBUG.DOCK.debug_mode_active') )
        "
        :title="
          DockStatus == true
            ? $e(`Désactiver le mode debug`)
            : $e(`Activer le mode debug`)
        "
      >
        <svg
          :class="smallSvg ? 'w-[17px]' : 'w-[25px]'"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 251.81 309.45"
        >
          <g>
            <path
              d="M218.43,309.44v-12.13H33.37v12.14H12.15v-12.14h-.45c-6.46,0-11.7-5.24-11.7-11.7h0V71.5c0-19.38,15.71-35.09,35.09-35.09h140.86V0h21.25v36.4h19.52c19.38,0,35.09,15.71,35.09,35.09v214.12c0,6.46-5.24,11.7-11.7,11.7h-.45v12.14l-21.23-.02Z"
              style="fill: #fff"
            />
            <path
              d="M155.22,140.74l59.18,53.08c1.7,1.55,4.34,1.42,5.88-.29.1-.11.19-.22.27-.33l11.56-14.74c1.54-1.97,1.33-4.79-.48-6.52l-59.15-53.13c-1.72-1.53-4.35-1.37-5.88.35,0,0,0,0,0,0-.09.1-.17.2-.25.31l-11.58,14.72c-1.57,1.97-1.37,4.81.45,6.55"
              style="fill: #3e3e3e"
            />
            <path
              d="M232.78,172.51c6.01,5.05,6.79,14.01,1.74,20.02-5.05,6.01-14.01,6.79-20.02,1.74-6.01-5.05-6.79-14.01-1.74-20.02,5.05-6.01,14.01-6.79,20.02-1.75,0,0,0,0,0,0"
              style="fill: #fff"
            />
            <path
              d="M232.78,172.52c6,5.04,6.78,14,1.74,20.01-5.04,6-14,6.78-20.01,1.74-6-5.04-6.78-14-1.74-20,5.04-6.01,14-6.79,20.01-1.75,0,0,0,0,0,0Z"
              style="
                fill: none;
                stroke: #545454;
                stroke-miterlimit: 4;
                stroke-width: 5.85px;
              "
            />
            <path
              d="M170.45,112.96c7.24,6.08,8.18,16.89,2.1,24.13-6.08,7.24-16.89,8.18-24.13,2.1-7.24-6.08-8.18-16.89-2.1-24.13,0,0,0,0,0,0,6.08-7.24,16.89-8.18,24.13-2.1"
              style="fill: #9f9f9f"
            />
            <path
              d="M168.56,115.2c6,5.04,6.78,14,1.74,20.01-5.04,6-14,6.78-20.01,1.74-6-5.04-6.78-14-1.74-20,5.04-6.01,14-6.79,20.01-1.75,0,0,0,0,0,0Z"
              style="
                fill: none;
                stroke: #545454;
                stroke-miterlimit: 4;
                stroke-width: 5.85px;
              "
            />
            <path
              d="M150.3,136.96c-6.01-5.04-6.79-14.01-1.74-20.01,5.04-6.01,14.01-6.79,20.01-1.74,6.01,5.04,6.79,14,1.74,20.01-5.05,6-14,6.78-20.01,1.74"
              style="fill: #fff"
            />
            <path
              d="M166.69,117.44c-4.77-4.01-11.89-3.39-15.89,1.38-4.01,4.77-3.39,11.89,1.38,15.89s11.89,3.39,15.89-1.38h0c4-4.77,3.38-11.88-1.39-15.89M170.45,112.96c7.24,6.08,8.18,16.89,2.1,24.13s-16.89,8.18-24.13,2.1c-7.24-6.08-8.18-16.89-2.1-24.13,0,0,0,0,0,0,6.08-7.24,16.89-8.18,24.13-2.1"
              style="fill: #545454"
            />
            <path
              d="M96.54,140.72l-59.17,53.09c-1.7,1.54-4.33,1.41-5.87-.29-.1-.11-.19-.23-.28-.35l-11.58-14.72c-1.54-1.97-1.33-4.79.49-6.52l59.17-53.14c1.72-1.53,4.35-1.37,5.88.35,0,0,0,0,0,0,.09.1.17.2.24.3l11.58,14.72c1.57,1.97,1.37,4.82-.45,6.55"
              style="fill: #3e3e3e"
            />
            <path
              d="M37.26,194.26c-6.01,5.04-14.96,4.26-20.01-1.75-5.04-6.01-4.26-14.96,1.75-20.01,6.01-5.04,14.96-4.26,20,1.74,5.04,6,4.27,14.96-1.74,20.01h0"
              style="fill: #fff"
            />
            <path
              d="M37.26,194.26c-6.01,5.04-14.96,4.26-20.01-1.75-5.04-6.01-4.26-14.96,1.75-20.01,6.01-5.04,14.96-4.26,20,1.74,5.04,6,4.27,14.96-1.74,20.01h0Z"
              style="
                fill: none;
                stroke: #545454;
                stroke-miterlimit: 4;
                stroke-width: 5.85px;
              "
            />
            <path
              d="M101.46,136.94c-6.01,5.04-14.96,4.26-20.01-1.75s-4.26-14.96,1.75-20.01c6.01-5.04,14.96-4.26,20,1.74,5.04,6,4.27,14.96-1.74,20.01,0,0,0,0,0,0"
              style="fill: #fff"
            />
            <path
              d="M101.46,136.94c-6.01,5.04-14.96,4.26-20.01-1.75s-4.26-14.96,1.75-20.01c6.01-5.04,14.96-4.26,20,1.74,5.04,6,4.27,14.96-1.74,20.01,0,0,0,0,0,0Z"
              style="
                fill: none;
                stroke: #545454;
                stroke-miterlimit: 4;
                stroke-width: 5.85px;
              "
            />
          </g>
        </svg>
        <div>
          <p>{{ $e("Mode debug") }}</p>
          <span class="toogle_info">
            <p v-if="DockStatus">{{ $e("Désactiver le mode debug") }}</p>
            <p v-else>{{ $e("Activer le mode debug") }}</p>
          </span>
        </div>
        <div
          class="block w-[15px] h-[15px] ml-4 rounded-full"
          :class="DockStatus ? 'bg-success' : 'bg-error'"
        ></div>
      </div>
    </div>

    <template v-if="!DockStatus">
      <div
        class="text-error top-0 left-0 w-full h-full bg-g1/80 flex items-center justify-center"
      >
        {{ $e("Activer le débogage à distance pour accéder aux actions") }}
      </div>
    </template>

    <template v-else>
      <div class="content_device_action">
        <!-- Redémarrer le dock  -->
        <div
          @click.stop.prevent="dock_reboot()"
          :title="$e(`Redémarrer le dock`)"
        >
          <svg
            :class="smallSvg ? 'w-[17px]' : 'w-[25px]'"
            class="fill-current"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 162.22 177.88"
          >
            <path
              d="M46.7,46.56l-7.55,7.41c-11.1,10.89-17.98,26.04-17.98,42.82,0,33.11,26.84,59.94,59.94,59.94s59.94-26.84,59.94-59.94c0-16.78-6.87-31.93-17.98-42.82l-7.55-7.41,14.81-15.12,7.55,7.41c15,14.72,24.33,35.24,24.33,57.93,0,44.79-36.32,81.1-81.11,81.1S0,141.58,0,96.78c0-22.69,9.33-43.22,24.33-57.93l7.56-7.41,14.81,15.12Z"
            />
            <path d="M91.7,0v68.18h-21.17V0h21.17Z" />
          </svg>
          <div>
            <p>{{ $e("Dock")}}</p>
            <span class="toogle_info">
              <p>{{ $e("Redémarrer le dock") }}</p>
            </span>
          </div>
        </div>
        <!-- Capot  -->
        <div
          @click.stop.prevent="dock_cover()"
          :title="
            DockCoverState
              ? $e(`Ouvir le capot du dock`)
              : $e(`Fermer le capot du dock`)
          "
        >
          <svg
            :class="smallSvg ? 'w-[30px]' : 'w-[50px]'"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 591.092 322.568"
          >
            <g
              id="Groupe_281"
              data-name="Groupe 281"
              clip-path="url(#clip-path)"
            >
              <path
                id="Tracé_534"
                data-name="Tracé 534"
                d="M416.712,210.937a9.973,9.973,0,0,1-4.583-1.116l-67.953-35.1H246.959l-67.953,35.11a9.977,9.977,0,0,1-9.364-.1v89a11.7,11.7,0,0,0,11.7,11.7h.445v12.141h21.229V310.427H388.069v12.129l21.228.012V310.427h.457a11.7,11.7,0,0,0,11.7-11.7V209.745a10.038,10.038,0,0,1-4.738,1.192"
                fill="#fff"
              ></path>
              <path
                id="Tracé_535"
                data-name="Tracé 535"
                d="M468.74,58.123l-16.9-8.726,17.784-27.44-18.394-9.5-17.79,27.449-43.32-22.372L314.2,134.682a17.352,17.352,0,0,0,3.151,14.934l99.369,51.319,65.25-100.674c9.468-14.609,3.545-33.476-13.228-42.138"
                fill="#fff"
              ></path>
              <path
                id="Tracé_536"
                data-name="Tracé 536"
                d="M277.219,135.149,201.393,18.208,122.8,58.816c-16.776,8.668-22.764,27.419-13.384,41.886l65,100.249,99.682-51.5a17.313,17.313,0,0,0,3.121-14.3"
                fill="#fff"
              ></path>
              <path
                id="Tracé_537"
                data-name="Tracé 537"
                d="M355.422,125.285l24.641,75.577a4.165,4.165,0,0,0,5.64,2.547l17.386-6.964a4.867,4.867,0,0,0,2.844-5.885l-24.589-75.607a4.166,4.166,0,0,0-5.265-2.642,3.883,3.883,0,0,0-.371.143l-17.394,6.941a4.868,4.868,0,0,0-2.892,5.89"
                fill="#3e3e3e"
              ></path>
              <path
                id="Tracé_538"
                data-name="Tracé 538"
                d="M406.639,191.634a14.2,14.2,0,1,1-18.194-8.511,14.2,14.2,0,0,1,18.194,8.511"
                fill="#fff"
              ></path>
              <path
                id="Tracé_539"
                data-name="Tracé 539"
                d="M406.639,191.634a14.2,14.2,0,1,1-18.194-8.511A14.2,14.2,0,0,1,406.639,191.634Z"
                fill="none"
                stroke="#545454"
                stroke-miterlimit="4.001"
                stroke-width="5.85"
              ></path>
              <path
                id="Tracé_540"
                data-name="Tracé 540"
                d="M382.514,108.867A17.128,17.128,0,1,1,360.574,98.6a17.128,17.128,0,0,1,21.94,10.263"
                fill="#9f9f9f"
              ></path>
              <path
                id="Tracé_541"
                data-name="Tracé 541"
                d="M379.765,109.864a14.2,14.2,0,1,1-18.194-8.511A14.2,14.2,0,0,1,379.765,109.864Z"
                fill="none"
                stroke="#545454"
                stroke-miterlimit="4.001"
                stroke-width="5.85"
              ></path>
              <path
                id="Tracé_542"
                data-name="Tracé 542"
                d="M353.056,119.551a14.205,14.205,0,1,1,18.2,8.512,14.222,14.222,0,0,1-18.2-8.512"
                fill="#fff"
              ></path>
              <path
                id="Tracé_543"
                data-name="Tracé 543"
                d="M377.016,110.863a11.281,11.281,0,1,0-6.76,14.45,11.294,11.294,0,0,0,6.76-14.45m5.5-1.994A17.13,17.13,0,1,1,360.571,98.6a17.131,17.131,0,0,1,21.944,10.265"
                fill="#545454"
              ></path>
              <path
                id="Tracé_544"
                data-name="Tracé 544"
                d="M235.623,125.281l-24.616,75.585a4.157,4.157,0,0,1-5.646,2.533l-17.4-6.938a4.866,4.866,0,0,1-2.845-5.884l24.6-75.63a4.163,4.163,0,0,1,5.264-2.642c.122.04.242.086.359.137l17.4,6.939a4.867,4.867,0,0,1,2.889,5.9"
                fill="#3e3e3e"
              ></path>
              <path
                id="Tracé_545"
                data-name="Tracé 545"
                d="M210.036,200.921a13.036,13.036,0,1,1-7.815-16.7,13.037,13.037,0,0,1,7.815,16.7"
                fill="#fff"
              ></path>
              <path
                id="Tracé_546"
                data-name="Tracé 546"
                d="M211.132,201.319a14.2,14.2,0,1,1-8.514-18.192A14.2,14.2,0,0,1,211.132,201.319Z"
                fill="none"
                stroke="#545454"
                stroke-miterlimit="4.001"
                stroke-width="5.85"
              ></path>
              <path
                id="Tracé_547"
                data-name="Tracé 547"
                d="M237.991,119.544a14.2,14.2,0,1,1-8.514-18.192,14.2,14.2,0,0,1,8.514,18.192"
                fill="#fff"
              ></path>
              <path
                id="Tracé_548"
                data-name="Tracé 548"
                d="M237.991,119.544a14.2,14.2,0,1,1-8.514-18.192A14.2,14.2,0,0,1,237.991,119.544Z"
                fill="none"
                stroke="#545454"
                stroke-miterlimit="4.001"
                stroke-width="5.85"
              ></path>
            </g>
          </svg>
          <div>
            <p>{{ $e("Capot du dock") }}</p>
            <span class="toogle_info">
              <p v-if="DockCoverState">{{ $e("Ouvir le capot du dock") }}</p>
              <p v-else>{{ $e("Fermer le capot du dock") }}</p>
            </span>
          </div>

          <div
            class="block min-w-[10px] min-h-[10px] ml-4 rounded-full"
            :class="{
              'bg-error': DockCoverStateNumber == 0,
              'bg-success': DockCoverStateNumber == 1,
              'bg-warning': DockCoverStateNumber == 2,
            }"
          ></div>
        </div>

        <!-- Putter  -->
        <div
          v-if="config.deviceFamilly.this_det_id == 10 || $root.debug"
          @click.stop.prevent="drone_putter(DockerPutterState)"
          :title="
            DockerPutterState
              ? $e(`Ouvrir les barre de recentrage du drone`)
              : $e(`Fermer les barre de recentrage du drone`)
          "
        >
          <svg
            :class="smallSvg ? 'w-[17px]' : 'w-[25px]'"
            class="fill-current"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 308.95 308.95"
          >
            <path
              d="M308.95,142.76V0h-134.41v80h-40.14V0H0v136.19h50v40.14H0v132.63h134.41v-80h40.14v80h134.41v-126.05h-50v-40.14h50ZM204.14,205.76h-37.31v-43.97h-28v43.97h-37.14v-102.57h37.14v38.77h28v-38.77h37.31v102.57Z"
            />
          </svg>
          <div>
            <p>{{ $e("Barres de recentrage") }}</p>
            <span class="toogle_info">
              <p v-if="DockerPutterState">
                {{ $e("Ouvrir les barre de recentrage du drone") }}
              </p>
              <p v-else>{{ $e("Fermer les barre de recentrage du drone") }}</p>
            </span>
          </div>
        </div>
      </div>

      <div class="content_device_action">
        <!-- Drone  -->
        <div
          @click.stop.prevent="drone_start(DroneStatus)"
          :title="
            DroneStatus ? $e(`Allumer le drone`) : $e(`Éteindre le drone`)
          "
        >
          <svg
            :class="smallSvg ? 'w-[17px]' : 'w-[25px]'"
            class="fill-current"
            xmlns="http://www.w3.org/2000/svg"
            width="21.215"
            height="21.334"
            viewBox="0 0 21.215 21.334"
          >
            <g transform="translate(0 11)">
              <path
                d="M4.552.005a4.549,4.549,0,0,1,4.543,4.28l.008.268H7.57A3.018,3.018,0,1,0,4.326,7.56l.226.009V9.1a4.548,4.548,0,1,1,0-9.1Zm0,12.1v1.532A3.035,3.035,0,1,0,7.561,16.88l.009-.226H9.1a4.551,4.551,0,1,1-4.817-4.54l.267-.008Zm12.11,0a4.615,4.615,0,1,1-4.544,4.815l-.007-.268h1.532a3.018,3.018,0,1,0,3.244-3.006l-.226-.009V12.107Zm0-12.1a4.548,4.548,0,0,1,.267,9.088l-.267.008V7.569a3.035,3.035,0,1,0-3.009-3.241l-.009.226H12.111A4.549,4.549,0,0,1,16.661.005ZM16.867,15.8a.832.832,0,1,1-1.112.933,3.287,3.287,0,0,0-.518-.6c-.17-.173-.579-.473-1.046-.842a6.643,6.643,0,0,0-3.546-1.7A5.561,5.561,0,0,0,7.682,14.9c-.244.17-.712.523-1.324.98a4.078,4.078,0,0,0-.973,1.083l-.008-.008a.836.836,0,1,1-.958-1.183,1.806,1.806,0,0,0,.9-.639,19.84,19.84,0,0,0,1.265-1.6,5.379,5.379,0,0,0,1.283-2.788,4.843,4.843,0,0,0-1.186-2.7c-.212-.315-.667-.9-1.126-1.465A4.53,4.53,0,0,0,4.22,5.357l0,0a.833.833,0,1,1,1.233-.874,5.187,5.187,0,0,0,1.13,1.273s1.023.768,1.283.939a5.055,5.055,0,0,0,5.776-.106c.591-.485,1.589-1.25,1.589-1.25a2.432,2.432,0,0,0,.506-.755.837.837,0,1,1,1.189.8h0a2.413,2.413,0,0,0-.847.774s-.529.742-1.17,1.561a5.365,5.365,0,0,0-1.432,3.14,5.425,5.425,0,0,0,1.535,3.027,9.543,9.543,0,0,0,1.258,1.488,2.3,2.3,0,0,0,.588.427Z"
                transform="translate(0 -11.005)"
                fill-rule="evenodd"
              ></path>
            </g>
          </svg>
          <div>
            <p>{{ $e("Drone") }}</p>
            <span class="toogle_info">
              <p v-if="DroneStatus">{{ $e("Allumer le drone") }}</p>
              <p v-else>{{ $e("Éteindre le drone ") }}</p>
            </span>
          </div>

          <div
            class="block min-w-[10px] min-h-[10px] ml-4 rounded-full"
            :class="!DroneStatus ? 'bg-success' : 'bg-error'"
          ></div>
        </div>

        <!-- Batterie  -->
        <div
          @click.stop.prevent="drone_charge(!DroneIsCharging)"
          v-if="!DroneStatus"
          :title="
            !DroneIsCharging
              ? $e(`Mettre en charge les batteries du drone`)
              : $e('Arrêter la charges des batteries du drone')
          "
        >
          <svg
            :class="smallSvg ? 'w-[22px]' : 'w-[32px]'"
            class="fill-current"
            viewBox="0 0 82 46"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.299988 0.900024V45.1H71.1V34.5H81.7V11.5H71.1V0.900024H0.299988ZM65.1 39.1H6.29999V6.90003H65.1V39.1ZM75.7 17.5V28.5H71.1V17.5H75.7Z"
            ></path>
            <path class="b1" d="M21.1 14H15.1V32.08H21.1V14Z"></path>
            <path class="b2" d="M38.2 14H32.2V32.08H38.2V14Z"></path>
            <path class="b3" d="M55.2 14H49.2V32.08H55.2V14Z"></path>
          </svg>
          <div>
            <p>{{ $e("Batteries") }}</p>
            <span class="toogle_info">
              <p v-if="!DroneIsCharging">
                {{ $e("Mettre en charge les batteries du drone") }}
              </p>
              <p v-else>
                {{ $e("Arrêter la charges des batteries du drone") }}
              </p>
            </span>
          </div>
          <div
            class="block min-w-[10px] min-h-[10px] ml-4 rounded-full"
            :class="DroneIsCharging ? 'bg-success' : 'bg-error'"
          ></div>
        </div>
      </div>

      <div
        class="w-full border-t border-g3 flex justify-between flex-col p-1 mb-1"
      >
        <div>
          {{ $e("Contrôle de l'air") }} :
          <span
            v-if="this.config?.dock?.status?.air_conditioner?.switch_time != 0"
            class="font-bold cursor-help"
            :title="$e('Vous devez attendre avant d\'effectuer une nouvelle action')"
          >
            {{ this.config?.dock?.status?.air_conditioner?.switch_time }}s
          </span>
        </div>
        <div class="flex justify-between mt-2">
          <button
            @click.stop.prevent="dock_clim(0)"
            :class="classBtn + dockclim_Class(0)"
          >
            <span> {{ $e("Inactif") }} </span>
          </button>
          <button
            @click.stop.prevent="dock_clim(1)"
            :class="classBtn + dockclim_Class(1)"
          >
            <span> {{ $e("Refroidissement") }} </span>
          </button>
          <button
            @click.stop.prevent="dock_clim(2)"
            :class="classBtn + dockclim_Class(2)"
          >
            <span> {{ $e("Chauffage") }} </span>
          </button>
          <button
            @click.stop.prevent="dock_clim(3)"
            :class="classBtn + dockclim_Class(3)"
          >
            <span> {{ $e("Déshumidification") }} </span>
          </button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import API from "@/utils/API";

export default {
  props: {
    config: Object,
    smallSvg: Boolean,
  },
  setup() {
    return {
      classBtn: `bg-g2 cursor-pointer flex h-full hover:bg-flyingeye-light items-center justify-center px-3 !py-[1px] rounded-lg  !h-fit `,
    };
  },
  methods: {
    async dock_debug(state) {
      let data = null;

      if (!this.DockStatus) {
        data = await API.put("debugon", {
          DevId: this.config?.dock?.id,
        });

        data.name = this.$e("Activation du débogage à distance");
      } else {
        data = await API.put("debugoff", {
          DevId: this.config?.dock?.id,
        });

        data.name = this.$e("Désactivation du débogage à distance");
      }
      this.$root.msg_replie[data.command] = {
        id: data.command,
        name: data.name,
      };
    },

    async dock_cover() {
      let data = null;
      if (this.config?.dock?.status?.cover_state == 0) {
        data = await API.put("dockopencover", {
          DevId: this.config?.dock?.id,
        });

        data.name = "Ouverture du dock";
      } else {
        data = await API.put("dockclosecover", {
          DevId: this.config?.dock?.id,
        });

        data.name = "Fermeture du dock";
      }
      this.$root.msg_replie[data.command] = {
        id: data.command,
        name: data.name,
      };
    },

    async dock_reboot() {
      this.$root.confirm_open({
        message: "Êtes-vous sûr de vouloir redémarrer le dock ?",
        true: async () => {
          let data = await API.put("dockreboot", {
            DevId: this.config?.dock?.id,
          });

          this.$root.msg_replie[data.command] = {
            id: data.command,
            name: "Redémarrage du dock",
          };
        },
        false: () => {},
      });
      return;
    },

    async dock_clim(state) {
      if (
        this.config?.dock?.status?.air_conditioner?.air_conditioner_state == 4
      ) {
        return;
      }

      let data = await API.put("dockairconmode", {
        DevId: this.config?.dock?.id,
        Mode: state,
      });

      switch (state) {
        case 0:
          data.name = "Changement du contrôle de l'air pour le mode inactif";
          break;
        case 1:
          data.name =
            "Changement du contrôle de l'air pour le mode refroidissement";
          break;
        case 2:
          data.name = "Changement du contrôle de l'air pour le mode chauffage";
          break;
        case 3:
          data.name =
            "Changement du contrôle de l'air pour le mode déshumidification";
          break;

        default:
          data.name = "Contrôle de l'air, action inconnue";
          break;
      }

      this.$root.msg_replie[data.command] = {
        id: data.command,
        name: data.name,
      };
    },

    async kill_flight() {
      if (!Number.isInteger(this.config?.flight?.id)) {
        // console.log("----------");
        return;
      }

      await API.put("flightrunend", {
        FlrId: this.config.flight?.flr_id,
      });

      this.config.flight = {};
    },

    /* ----------------- Drone ----------------- */

    async drone_start(state) {
      let data = null;

      if (state) {
        data = await API.put("droneon", {
          DevId: this.config?.dock?.id,
        });

        data.name = this.$e("Allumage du drone");
      } else {
        data = await API.put("droneoff", {
          DevId: this.config?.dock?.id,
        });

        data.name = this.$e("Extinction du drone");
      }

      this.$root.msg_replie[data.command] = {
        id: data.command,
        name: data.name,
      };
    },

    async drone_charge(state) {
      let data = null;
      if (state) {
        data = await API.put("dockchargeon", {
          DevId: this.config?.dock?.id,
        });

        data.name = this.$e("Mise en charge des batteries");
      } else {
        data = await API.put("dockchargeon", {
          DevId: this.config?.dock?.id,
        });

        data.name = this.$e("Arrêt de la mise en charge des batteries");
      }

      this.$root.msg_replie[data.command + ""] = {
        id: data.command,
        name: data.name,
      };
    },

    async drone_putter(state) {
      let data = null;
      if (state) {
        data = await API.put("dockopenputter", {
          DevId: this.config?.dock?.id,
        });

        data.name = this.$e("Ouverture des barres de recentrage");
      } else {
        data = await API.put("dockcloseputter", {
          DevId: this.config?.dock?.id,
        });

        data.name = this.$e("Fermeture des barres de recentrage");
      }
      this.$root.msg_replie[data.command] = {
        id: data.command,
        name: data.name,
      };
    },

    dockclim_Class(state) {
      if (
        this.config?.dock?.status?.air_conditioner?.switch_time != 0 ||
        this.config?.dock?.status?.air_conditioner?.air_conditioner_state == 4
      ) {
        return "opacity-60";
      } else if (
        this.config?.dock?.status?.air_conditioner?.air_conditioner_state ==
        state
      ) {
        return "!bg-flyingeye";
      }
      return "";
    },
  },

  computed: {
    canKill() {
      return Number.isInteger(this.config?.flight?.id);
    },

    DroneStatus() {
      if (this.config?.drone?.status?.LastPing != undefined) {
        return this.config.drone.status.LastPing > ENV.DEVICE_OFFLINE;
      }
      return true;
    },

    DockStatus() {
      if (this.config?.dock?.status?.mode_code != undefined) {
        return this.config?.dock?.status.mode_code == 2;
      }
      return false;
    },

    DockCoverState() {
      if (this.config?.dock?.status?.cover_state != undefined) {
        return this.config?.dock?.status.cover_state == 0;
      }
      return true;
    },

    DockCoverStateNumber() {
      if (this.config?.dock?.status?.cover_state != undefined) {
        return this.config?.dock?.status.cover_state;
      }
      return -1;
    },

    DockerPutterState() {
      if (this.config?.dock?.status?.putter_state != undefined) {
        return this.config?.dock?.status.putter_state == 0;
      }
      return true;
    },

    DockerPutterStateNumber() {
      if (this.config?.dock?.status?.putter_state != undefined) {
        return this.config?.dock?.status.putter_state;
      }
      return -1;
    },

    DroneIsCharging() {
      return this.config?.dock?.status?.drone_charge_state?.state != undefined
        ? this.config.dock.status.drone_charge_state.state == 1
        : false;
    },
  },
};
</script>
